import TablePagination from "../../../common/pagination/TablePagination";
import { Table } from "react-bootstrap";
import SchoolTableRow from "./SchoolTableRow";
import TableError from "../../common/TableError";
import { ITEMS_PER_PAGE } from "../../../../constant/constant";
import TableSkeleton from "../../common/TableSkeleton";

const SchoolTable = ({
  schools,
  loading,
  error,
  metaData,
  currentPage,
  setCurrentPage,
  handleRefresh,
  isSearching,
  debouncedSearch,
}) => {
  // Show skeleton only on initial load (when schools is undefined and loading)
  if (loading && schools === undefined) {
    return <TableSkeleton rows={ITEMS_PER_PAGE} columns={7} />;
  }

  if (error || schools === null) {
    return (
      <TableError error={error} handleRefresh={handleRefresh} loading={loading} />
    );
  }

  if (!schools || schools.length === 0) {
    return (
      <div className="alert alert-info mt-3" role="alert">
        {isSearching
          ? `No schools found matching "${debouncedSearch}".`
          : "No schools found."}
      </div>
    );
  }

  const totalPages = metaData?.last_page || 1;

  return (
    <div>
      <div className="custom-table-container mt-3">
        <div className="custom-table-wrapper">
          <Table hover className="custom-table">
            <thead className="custom-table-head">
              <tr>
                <th>School Name</th>
                <th>Students</th>
                <th>Avg. Completion (%)</th>
                <th>Avg. Quiz Score (%)</th>
                <th>Pass Rate</th>
                <th>Avg. Attempts</th>
                <th>Details</th>
              </tr>
            </thead>
            <tbody>
              {schools.map((school) => {
                return (
                  <SchoolTableRow
                    key={school.school_id}
                    school={school}
                    disabled={loading}
                  />
                );
              })}
            </tbody>
          </Table>
        </div>

        <TablePagination
          totalPage={totalPages}
          currentPage={currentPage}
          onPageChange={setCurrentPage}
          disabled={loading}
        />
      </div>
    </div>
  );
};

export default SchoolTable;
